
import { CategoriesManagement } from "./CategoriesManagement";

export const CategoriesTagsSection = () => {
  return (
    <div className="space-y-6">
      <CategoriesManagement />
    </div>
  );
};
